import z from "zod";
import { externalClient } from "../clients";
import { validateResponse } from "../validation";

export const airlineResponseSchema = z.object({
  name: z.string(),
  code: z.string().nullable(),
  ec261: z.boolean(),
  country_code: z.string(),
  display_name: z.string(),
  iata: z.string().nullable(),
  icao: z.string().nullable(),
  unique_identifier: z.string(),
});

const airlinesResponseSchema = z.object({
  airlines: z.array(airlineResponseSchema),
});

export type RawAirline = z.infer<typeof airlineResponseSchema>;

export async function fetchAirlines(searchTerm: string) {
  const data = await externalClient
    .get("api/airlines", {
      searchParams: {
        q: searchTerm,
      },
    })
    .json();

  const result = validateResponse({
    data,
    schema: airlinesResponseSchema,
    tag: "Airlines API response",
  });

  return result.airlines;
}
